export var ACTION;
(function (ACTION) {
    ACTION["NAVIGATE_CUSTOMER_SCREEN"] = "NAVIGATE_CUSTOMER_SCREEN";
    ACTION["DOWNLOAD_HOLDING_DETAILS"] = "DOWNLOAD_HOLDING_DETAILS";
    ACTION["DOWNLOAD_SOA_DETAILS"] = "DOWNLOAD_SOA_DETAILS";
    ACTION["SHARE_LINK_REF"] = "SHARE_LINK_REF";
    ACTION["START_JOURNEY"] = "START_JOURNEY";
})(ACTION || (ACTION = {}));
